import styled from 'styled-components'

import { Container } from '@/components/shared/Container'

import { GutShotGuideSectionFeatures } from './GutShotGuideSectionFeatures'

const StyledGuideSection = styled.section`
  background-color: #e3f0ec;
  border-radius: 24px;
  margin: 0 auto;
  padding: 48px 48px 16px;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    border-radius: 32px;
    padding: 48px 0 32px; // no horizontal padding for off screen effect
  }
`

const StyledTitleAndDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;

  > * {
    flex: 1;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: 16px;
    padding-left: 24px;
    padding-right: 24px;
  }

  h2 {
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: ${(p) => p.theme.v2.typography.display.xxl.fontSize};
    line-height: 92px;
    margin: 0;
    max-width: 550px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: 42px;
      line-height: 56px;
    }
  }

  p {
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: ${(p) => p.theme.v2.typography.body.xxl.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.xxl.lineHeight};
    margin: 0;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.l.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.l.lineHeight};
    }
  }
`

const StyledHr = styled.hr`
  height: 1px;
  background-color: #e2e2e2;
  margin: 56px 0;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin: 32px 24px;
  }
`

export const GutShotGuideSection = () => {
  return (
    <Container $size="wide" $padding="no-mobile">
      <StyledGuideSection>
        <StyledTitleAndDescription>
          <h2>What&apos;s in the guide?</h2>
          <p>
            Your gut microbiome plays a key role in your health. Follow our simple, actionable tips to improve your gut
            health and start feeling your best.
          </p>
        </StyledTitleAndDescription>
        <StyledHr />
        <GutShotGuideSectionFeatures />
      </StyledGuideSection>
    </Container>
  )
}
